<template>
  <div class='main-container'>
    <v-navigation-drawer
      v-model='drawer'
      :mini-variant.sync='mini'
      permanent
      color='#f2f2f2'
      width='292'
      style='border: none'
    >
      <div class='position-relative' style='overflow: hidden; height: 100%;'>
        <div v-if='!mini' class='d-flex align-center justify-space-between'
             style='height: 90px; padding: 25px 10px 34px 20px'>
          <div>
            <v-tooltip right>
              <template v-slot:activator='{ on, attrs }'>
                <img v-bind='attrs' v-on='on' class='cursor-pointer' :src="require('@/assets/images/icon-收起.png')"
                     style='width: 30px; height: 30px;'
                     alt='' @click.stop='mini = !mini' />
              </template>
              <span>收起对话记录</span>
            </v-tooltip>
          </div>
        </div>
        <div v-show='!mini' style='margin-top: 0px'>
          <div class="pl-4 cursor-pointer" @click="showChats = !showChats">
            <span style="font-size: 14px; font-weight: 600; color: #100d1b">Chats</span>
            <v-icon size="18"
                    :style="{transform: showChats ? 'rotate(0deg)' : 'rotate(-90deg)', transition: 'transform 0.3s ease'}"
                    color="#100d1b">
              {{ icons.mdiChevronDown }}
            </v-icon>
          </div>
          <div v-if='showChats'
               class='position-relative'
               style='overflow-y: auto; height: calc(100vh - 220px)'>
            <v-list v-for='(item, i) in chatSessionList'
                    :key='item.chatSessionId'
                    style="padding-top: 0; padding-bottom: 0"
                    dense
                    rounded
            >
              <div
                @mouseover='mouseover(item)'
                @mouseleave='mouseleave(item)'
                @click='messageSearch(item)'
                style='height: 45px; width: 100%'
                class="mb-1"
              >
                <div
                  style='width: 100%; height: 100%'
                  :class="['d-flex',
                  'align-center',
                  'cursor-pointer',
                  'justify-space-between',
                  item.chatSessionId === chatSessionId && !item.renameFlag ? 'selected-item' : '',
                  item.showOption && !item.renameFlag ? 'hover-item' : ''
                  ]"
                >
                  <v-tooltip v-if='!item.renameFlag' top>
                    <template v-slot:activator='{ on, attrs }'>
                      <div style='width: 100%; padding: 0 10px' v-bind='attrs' v-on='on'
                           class='d-inline-block text-truncate'>
                          <span style='color: #292834; font-size: 12px'>
                            {{ item.queryName }}
                          </span>
                      </div>
                    </template>
                    <span>{{ item.queryName }}</span>
                  </v-tooltip>

                  <div v-else style='width: 100%'>
                    <v-text-field
                      autofocus
                      style='width: 100%'
                      v-model='item.queryName'
                      outlined
                      dense
                      hide-details
                      @blur='renameBlur(item)'
                    ></v-text-field>
                  </div>

                  <v-menu
                    ref="menuRef"
                    v-show='item.showOption'
                    bottom
                    left
                  >
                    <template v-slot:activator='{ on, attrs }'>
                      <v-btn
                        v-show='item.showOption && !item.renameFlag'
                        fab
                        text
                        x-small
                        icon
                        v-bind='attrs'
                        v-on='on'
                        @click='mouseover(item)'
                      >
                        <v-icon small size='18' color='#5e5669ad'>
                          {{ icons.mdiDotsHorizontal }}
                        </v-icon>
                      </v-btn>

                    </template>

                    <v-list dense>
                      <v-list-item
                        link
                        @click='rename(item)'
                      >
                        <v-list-item-title>
                          <v-icon small size='20'>
                            {{ icons.mdiPencilOutline }}
                          </v-icon>
                          Rename
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        link
                        @click='deleteMsg(item)'
                      >
                        <v-list-item-title>
                          <v-icon small size='20' color='#EF4444'>
                            {{ icons.mdiTrashCanOutline }}
                          </v-icon>
                          Delete
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </div>
            </v-list>
          </div>
        </div>

        <div v-show='mini'>
          <!--          <img v-show='mini' class='cursor-pointer'-->
          <!--               :src="require('@/assets/images/avatars/cssa_bot.png')"-->
          <!--               style='width: 38px; height: 38px; margin-top: 18px; margin-left: 10px'-->
          <!--               alt='' />-->
          <v-tooltip top>
            <template v-slot:activator='{ on, attrs }'>
              <img v-bind='attrs' v-on='on' class='cursor-pointer' :src="require('@/assets/images/icon-展开.png')"
                   style='width: 30px; height: 30px; margin-top: 38px; margin-left: 13px'
                   alt='' />
            </template>
            <span>展开对话记录</span>
          </v-tooltip>

          <!--          <v-tooltip top>-->
          <!--            <template v-slot:activator='{ on, attrs }'>-->
          <!--              <v-icon v-bind='attrs' v-on='on' size='28' style='margin-top: 38px; margin-left: 13px'-->
          <!--                      @click.stop='openNewChat()'>-->
          <!--                {{ icons.mdiChatPlusOutline }}-->
          <!--              </v-icon>-->
          <!--            </template>-->
          <!--            <span>新对话</span>-->
          <!--          </v-tooltip>-->
        </div>

        <div v-if='!mini' class='d-flex align-center'
             style='height: 62px; width: 100%; position: absolute; bottom: 0; padding: 18px 20px;'>

          <v-btn
            class="start-new-chat"
            :height='28'
            color='#ffffff'
            @mouseenter="startNewChatMouseenter"
            @mouseleave="startNewChatMouseleave"
            depressed
            :style="{borderRadius: '20px', border: startNewChatMouseenterFlag ? '2px solid #a100ff' : '1px solid #100d1b'}"
            block
            @click='openNewChat'
          >
            <v-icon size='15' color='#100d1b'>
              {{ icons.mdiPlus }}
            </v-icon>
            <span style='font-size: 14px; color: #100d1b; font-weight: 600; margin-left: 8px'>
              Start New Chat
            </span>
          </v-btn>
        </div>

        <!--          <v-avatar size='32' color='primary'-->
        <!--                    class='v-avatar-light-bg primary&#45;&#45;text'>-->
        <!--            <img :src='`https://myops.accenture.cn/myops/proxy/images/blog/${eid}.jpg`'-->
        <!--                 alt='' />-->
        <!--          </v-avatar>-->
        <!--          <span-->
        <!--            style='color: #525252; font-size: 14px'-->
        <!--            class='ml-2 d-inline-block text-truncate'>-->
        <!--            {{ personName }}-->
        <!--          </span>-->
        <!--          <div v-if='isOpsSuperAdmin' class='ml-2 cursor-pointer'-->
        <!--               style='border: 1px solid #a100ff; border-radius: 8px; width: 25px; text-align: center'-->
        <!--               @click="$router.push({path: 'management/query'})"-->
        <!--          >-->
        <!--            <span style='font-size: 13px; color: #000'>管</span>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div v-else style='height: 48px; width: 100%; position: absolute; bottom: 0'>-->
        <!--          <v-avatar size='32' color='primary'-->
        <!--                    style='margin-left: 12px'-->
        <!--                    class='v-avatar-light-bg primary&#45;&#45;text'>-->
        <!--            <img :src='`https://myops.accenture.cn/myops/proxy/images/blog/${eid}.jpg`'-->
        <!--                 alt='' />-->
        <!--          </v-avatar>-->
        <!--        </div>-->

      </div>
    </v-navigation-drawer>

    <v-dialog
      v-model='deleteMsgDialog'
      persistent
      width='420'
    >
      <v-card>
        <v-card-title style='font-size: 18px; color: #404040; font-weight: bold'>
          删除聊天？
        </v-card-title>
        <v-card-text>
          <span
            style='font-size: 14px; color: #404040'>您确定要删除此聊天吗？</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            @click='deleteMsgDialog = false'
          >
            取消
          </v-btn>
          <v-btn
            small
            :loading='deleteMagLoading'
            color='#EF4444'
            @click='deleteQueryMessage'
          >
            <span style='color: white'>删除</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  mdiTrashCanOutline,
  mdiChatPlusOutline,
  mdiDotsHorizontal,
  mdiPencilMinusOutline,
  mdiMenuUp,
  mdiMenuDown,
  mdiPencilOutline,
  mdiPlus,
  mdiChevronRight,
  mdiChevronDown,
} from '@mdi/js'
import {
  deleteByChatSessionId,
  renameChatSession,
} from '../api/index'
import { store } from '@/myops/core'
import {
  set_conversation_id,
} from '../util/ChatBotUtil'
import { mapGetters } from 'vuex'

export default {
  props: {
    chatSessionList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      drawer: true,
      mini: false,
      icons: {
        mdiTrashCanOutline,
        mdiChatPlusOutline,
        mdiDotsHorizontal,
        mdiPencilMinusOutline,
        mdiPencilOutline,
        mdiMenuUp,
        mdiMenuDown,
        mdiPlus,
        mdiChevronRight,
        mdiChevronDown,
      },
      deleteMsgDialog: false,
      deleteMag: null,
      deleteMagLoading: false,
      eid: store.state.user.user.eid,
      personName: null,
      selectedChatItem: null,
      oldQueryName: '',
      startNewChatMouseenterFlag: false,
      showChats: true,
    }
  },
  watch: {
    mini: {
      handler(val) {
        this.$emit('miniChange', val)
      },
    },
  },
  computed: {
    ...mapGetters({
      chatSessionId: 'chat/chatSessionId',
      modelType: 'chat/modelType',
    }),
    isOpsSuperAdmin() {
      const roleList = store.state.user.user.userExInfo.roleList || []
      return roleList.includes('ops_01')
    },
  },
  mounted() {
    this.personName = store.state.user.user.userExInfo.sapPersonalInfo.firstName
      + ' ' + store.state.user.user.userExInfo.sapPersonalInfo.lastName
  },
  methods: {
    startNewChatMouseenter() {
      this.startNewChatMouseenterFlag = true
    },
    startNewChatMouseleave() {
      this.startNewChatMouseenterFlag = false
    },
    async renameBlur(item) {
      this.$set(item, 'renameFlag', false)
      if (item.queryName) {
        await renameChatSession(item)
      } else {
        item.queryName = this.oldQueryName
      }
    },
    async openNewChat() {
      this.$emit('openNewChat')
    },
    messageSearch(item) {
      if (item.chatSessionId === this.chatSessionId) {
        return
      }
      store.commit('chat/SET_CHAT_SESSION_ID', item.chatSessionId)
      store.commit('chat/SET_MODEL_TYPE', item.modelType)
      set_conversation_id(item.conversationId)
      this.$emit('messageSearch', item)
    },
    deleteMsg(item) {
      this.deleteMsgDialog = true
      this.deleteMag = item
    },
    async rename(item) {
      this.oldQueryName = item.queryName
      this.$set(item, 'renameFlag', true)
    },
    async deleteQueryMessage() {
      this.deleteMagLoading = true
      await deleteByChatSessionId({ chatSessionId: this.deleteMag.chatSessionId })
      this.deleteMsgDialog = false
      this.deleteMagLoading = false
      this.$message.success('删除成功！')
      this.$emit('deleteQueryMessage')
    },
    mouseover(item) {
      this.$set(item, 'showOption', true)
    },
    mouseleave(item) {
      this.$set(item, 'showOption', false)
    },
  },
}
</script>
<style lang='scss' scoped>
.main-container {
  height: 100vh;
  overflow-y: hidden;
  border: none;

  ::v-deep .v-list-item {
    padding: 0;
  }

  ::v-deep .v-btn:not(.v-btn--round).v-size--default {
    height: 32px !important;
    //padding: 0 10px;
    //width: 119px;
  }

  ::v-deep .v-navigation-drawer__border {
    width: 0;
  }

  .hover-item {
    background: #ebe5fa;
    width: 100%;
    border-radius: 0;
    height: 100%;
  }

  .hover-item::before {
    content: '';
    position: absolute;
    height: 45px;
    width: 4px;
    background: #a100ff;
    left: 4px;
  }

  .selected-item {
    background: #ebe5fa;
    border-radius: 0;
    height: 100%;
  }

  .selected-item::before {
    content: '';
    position: absolute;
    height: 45px;
    width: 4px;
    background: #a100ff;
    left: 4px;
  }

  .gradient-text {
    font-size: 18px;
    font-weight: bold;
    background: linear-gradient(270.00deg, #a100ff 0%, #d87ab7 100%);
    -webkit-background-clip: text;
    color: transparent;
  }

  .new-chat-btn {
    width: 264px;
    height: 48px;
    border-radius: 8px;
    background: #fff;
  }

  /* 整个滚动条 */
  ::-webkit-scrollbar {
    width: 5px; /* 垂直滚动条宽度 */
    height: 5px; /* 水平滚动条高度 */
  }

  /* 滚动条轨道 */
  ::-webkit-scrollbar-track {
    background: #f1f1f1; /* 轨道背景色 */
    border-radius: 5px; /* 圆角 */
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    background: #888; /* 滑块颜色 */
    border-radius: 5px; /* 圆角 */
    //border: 1px solid #f1f1f1; /* 滑块边框 */
  }

  /* 滚动条滑块悬停效果 */
  ::-webkit-scrollbar-thumb:hover {
    background: #555; /* 悬停时滑块颜色 */
  }
}
</style>
